"use strict";
// Browser-safe approval and watch contracts shared by web and worker code.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IN_APP_AGENT_ACTIVE_RUN_STATUSES = exports.InAppAgentWatchFrameSchema = exports.InAppAgentWatchDoneFrameSchema = exports.InAppAgentWatchErrorFrameSchema = exports.InAppAgentWatchEventFrameSchema = exports.InAppAgentWatchStatusFrameSchema = exports.InAppAgentApprovalDecisionSchema = exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME = void 0;
exports.buildInAppAgentApprovalDecisionEvent = buildInAppAgentApprovalDecisionEvent;
exports.parseInAppAgentApprovalDecisionEvent = parseInAppAgentApprovalDecisionEvent;
exports.isActiveInAppAgentRunStatus = isActiveInAppAgentRunStatus;
const core_1 = require("@ag-ui/core");
const zod_1 = require("zod");
const types_1 = require("../features/inAppAgent/types");
/** Render-only approval history stored in the append-only event stream. */
exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME = "langfuse_approval_decision";
exports.InAppAgentApprovalDecisionSchema = zod_1.z.object({
    toolCallId: zod_1.z.string().min(1),
    approved: zod_1.z.boolean(),
    decidedByUserId: zod_1.z.string().min(1),
});
function buildInAppAgentApprovalDecisionEvent(decision) {
    return {
        type: core_1.EventType.CUSTOM,
        name: exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME,
        value: decision,
    };
}
function parseInAppAgentApprovalDecisionEvent(event) {
    if (event.type !== core_1.EventType.CUSTOM ||
        event.name !== exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME) {
        return undefined;
    }
    const parsed = exports.InAppAgentApprovalDecisionSchema.safeParse(event.value);
    return parsed.success ? parsed.data : undefined;
}
/** Conversation-scoped watch frames keyed by persisted sequence number. */
exports.InAppAgentWatchStatusFrameSchema = zod_1.z.object({
    type: zod_1.z.literal("status"),
    runId: zod_1.z.string(),
    status: types_1.InAppAgentRunStatusSchema,
    errorCode: zod_1.z.string().nullable().optional(),
    /** Cancellation is cooperative, so this may be true while status is RUNNING. */
    cancelRequested: zod_1.z.boolean().optional(),
});
exports.InAppAgentWatchEventFrameSchema = zod_1.z.object({
    type: zod_1.z.literal("event"),
    sequenceNumber: zod_1.z.number().int(),
    event: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
});
exports.InAppAgentWatchErrorFrameSchema = zod_1.z.object({
    type: zod_1.z.literal("error"),
    code: zod_1.z.string(),
    message: zod_1.z.string(),
});
/** Only this frame tells clients to stop reconnecting. */
exports.InAppAgentWatchDoneFrameSchema = zod_1.z.object({
    type: zod_1.z.literal("done"),
});
exports.InAppAgentWatchFrameSchema = zod_1.z.discriminatedUnion("type", [
    exports.InAppAgentWatchStatusFrameSchema,
    exports.InAppAgentWatchEventFrameSchema,
    exports.InAppAgentWatchErrorFrameSchema,
    exports.InAppAgentWatchDoneFrameSchema,
]);
/** A parked approval occupies neither a worker nor the conversation slot. */
exports.IN_APP_AGENT_ACTIVE_RUN_STATUSES = [types_1.InAppAgentRunStatus.QUEUED, types_1.InAppAgentRunStatus.RUNNING];
function isActiveInAppAgentRunStatus(status) {
    return exports.IN_APP_AGENT_ACTIVE_RUN_STATUSES.includes(status);
}
